import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import Header from "./Header";
import { Container, Row, Col } from "react-bootstrap";
import Footer from "./Footer";

function Complain() {
  const navigate = useNavigate();
  const server_url = localStorage.getItem("server_url");
  const dealer_id = localStorage.getItem("dealer_id");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [deletedProducts, setDeletedProducts] = useState(new Set());

  const today = new Date().toISOString().split("T")[0]; // Get today's date (YYYY-MM-DD)
  const pastDate = new Date();
  pastDate.setDate(pastDate.getDate() - 30);
  const last30Days = pastDate.toISOString().split("T")[0]; // Last 30 days date (YYYY-MM-DD)
  const [from, setFrom] = useState(last30Days);
  const [to, setTo] = useState(today);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    getOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [from, to]);

  const openDeleteModal = (productId) => {
    setSelectedProductId(productId);
    setShowDeleteModal(true);
  };

  const getOrders = async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealer_id);
      formData.append("from", from);
      formData.append("to", to);
      formData.append("complain_id", "");

      const { data } = await axios.post(`${server_url}complain.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (data.status === "1") {
        setOrders(data.result);
      } else {
        setOrders([]);
        // toast.warning(data.error);
      }
    } catch {
      toast.error("Please Try Again Later.");
    }
  };

  const removeComplain = async (complainId) => {
    setShowDeleteModal(false);
    if (!dealer_id) {
      navigate("/Logout");
    }
    setDeletedProducts((prev) => new Set(prev).add(complainId));
    if (!complainId) return toast.warning("Please select a complain");

    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealer_id);
      formData.append("complain_id", complainId);
      formData.append("qty", "0");

      const { data } = await axios.post(
        `${server_url}delete_complain.php`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (data.status === "1") {
        getOrders();
      } else {
        toast.warning(data.error || "Please Try Again Later.");
      }
    } catch {
      toast.error("Please Try Again Later.");
    }
  };

  return (
    <React.Fragment>
      <div className="page-wrapper">
        {/* Header - Always Sticky */}
        <div className="sticky-header">
          <Header />
        </div>

        <div className="transaction-content">
          <Container className="py-4">
            {/* Sticky Container for Date Filter */}
            <div className="sticky-top-section">
              {/* Date Filter Section - Sticky */}
              <div className="sticky-date-filter">
                <Row className="g-3" style={{marginBottom:"0px"}}>
                  <Col xs={6} md={6} style={{marginTop:"0px"}}>
                    <label htmlFor="from-date" className="form-label">
                      From Date
                    </label>
                    <input
                      id="from-date"
                      type="date"
                      className="form-control date-input"
                      value={from}
                      onChange={(e) => setFrom(e.target.value)}
                    />
                  </Col>
                  <Col xs={6} md={6} style={{marginTop:"0px"}}>
                    <label htmlFor="to-date" className="form-label">
                      To Date
                    </label>
                    <input
                      id="to-date"
                      type="date"
                      className="form-control date-input"
                      value={to}
                      onChange={(e) => setTo(e.target.value)}
                    />
                  </Col>
                </Row>
              </div>
            </div>

            {/* Complaints List */}
            <div className="complaints-container">
              {orders.map((data) => (
                <div className="complaint-card" key={data.complain_id}>
                  <div className="complaint-content">
                    <div className="complaint-header">
                      <div className="complaint-title-section">
                        <h1 className="complaint-title">
                          {data.complain_nature_of_issue}
                          {data.complain_status === "2" ? (
                            <span className="status-badge resolved">
                              {data.complain_status_text}
                            </span>
                          ) : data.complain_status !== "1" ? (
                            <span className="status-badge pending">
                              {data.complain_status_text}
                            </span>
                          ) : null}
                        </h1>
                        <h2 className="product-name">{data.product_name}</h2>
                        <p className="complaint-details">
                          Order ID: {data.order_id} <br />
                          Date: {data.complain_date} <br />
                          {data.complain_issued_quantity} /{" "}
                          {data.complain_supplied_quantity} <br />
                          {data.complain_dealer_review}
                        </p>
                      </div>

                      {/* Edit/Delete Buttons */}
                      {data.complain_status === "1" && (
                        <div className="action-buttons">
                          <h2 className="status-text">
                            {data.complain_status_text}
                          </h2>
                          <div className="button-group">
                            <Link
                              to={`/UpdateComplain/${data.complain_id}`}
                              className="action-button edit-button"
                            >
                              <i
                                className="fa fa-pencil"
                                aria-hidden="true"
                              ></i>
                            </Link>

                            <button
                              onClick={() => openDeleteModal(data.complain_id)}
                              className="action-button delete-button"
                            >
                              <i className="fa fa-trash" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Add Complain Button */}
            <div className="add-complaint-fab">
              <Link to="/AddComplain" className="add-complaint-button">
                + Add Complain
              </Link>
            </div>
          </Container>
        </div>

        <Footer />
      </div>

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Remove Complain</h5>
              <button
                className="modal-close"
                onClick={() => setShowDeleteModal(false)}
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to remove this complain?</p>
            </div>
            {!deletedProducts.has(selectedProductId) && (
              <div className="modal-footer">
                <button
                  className="btn-secondary"
                  onClick={() => setShowDeleteModal(false)}
                >
                  No
                </button>
                <button
                  className="btn-danger"
                  onClick={() => removeComplain(selectedProductId)}
                >
                  Yes
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      <style jsx>{`
        .page-wrapper {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }

        .transaction-content {
          flex: 1;
          background: #ffffff;
          min-height: 100vh;
          color: #000000;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
            sans-serif;
        }

        /* Sticky Header */
        .sticky-header {
          position: sticky;
          top: 0;
          z-index: 1000;
          width: 100%;
        }

        /* Sticky Top Section Container */
        .sticky-top-section {
          position: sticky;
          top: 66px; /* Adjust based on your header height */
          z-index: 999;
          background: #ffffff;
          margin: 0 -15px;
          padding-left: 15px;
          padding-right: 15px;
        }

        /* Sticky Date Filter */
        .sticky-date-filter {
          background: #ffffff;
        }

        .form-control:focus {
          color: #000000;
        }

        .form-label {
          color: #000000;
          font-weight: 600;
          margin-bottom: 0.5rem;
          display: block;
        }

        .date-input {
          background: #ffffff;
          border: 1px solid #e5e5e5;
          color: #000000;
          border-radius: 8px;
          padding: 0.75rem;
          font-size: 1rem;
        }

        .date-input:focus {
          border-color: #db4437;
          box-shadow: 0 0 0 0.2rem rgba(219, 68, 55, 0.25);
          background: #ffffff;
        }

        .date-input::-webkit-calendar-picker-indicator {
          filter: invert(0);
        }

        /* Complaints Container */
        .complaints-container {
          padding-top: 20px !important;
        }

        /* Complaint Card */
        .complaint-card {
          background: #ffffff;
          border-radius: 12px;
          margin-bottom: 15px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
          border: 1px solid #e5e5e5;
        }

        .complaint-content {
          padding: 15px;
        }

        .complaint-header {
          display: flex;
          flex-direction: column;
        }

        .complaint-title-section {
          flex: 1;
        }

        .complaint-title {
          font-size: 18px;
          font-weight: 600;
          color: #000000;
          margin: 0 0 8px 0;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
        }

        .status-badge {
          font-size: 14px;
          font-weight: 600;
          padding: 3px 8px;
          border-radius: 12px;
          margin-left: 8px;
        }

        .status-badge.resolved {
          background: rgba(76, 175, 80, 0.1);
          color: #4caf50;
        }

        .status-badge.pending {
          background: rgba(244, 67, 54, 0.1);
          color: #f44336;
        }

        .product-name {
          font-size: 16px;
          color: #4caf50;
          margin: 0 0 8px 0;
          font-weight: 500;
        }

        .complaint-details {
          font-size: 14px;
          color: #333333;
          margin: 0;
          line-height: 1.4;
        }

        /* Action Buttons */
        .action-buttons {
          margin-top: 15px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .status-text {
          font-size: 16px;
          color: #ff9800;
          margin: 0;
        }

        .button-group {
          display: flex;
          gap: 10px;
        }

        .action-button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background: #000000;
          border: 1px solid #000000;
          color: #ffffff;
          text-decoration: none;
          font-size: 14px;
          transition: all 0.3s ease;
        }

        .action-button:hover {
          background: #333333;
          border-color: #333333;
        }

        .edit-button {
          color: #ffffff;
        }

        .delete-button {
          color: #ffffff;
        }

        /* Add Complaint Button */
        .add-complaint-fab {
          position: fixed;
          bottom: 80px;
          right: 20px;
          z-index: 100;
        }

        .add-complaint-button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 150px;
          height: 48px;
          background: #000000;
          color: white;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 600;
          text-decoration: none;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          border: 1px solid #000000;
          transition: all 0.3s ease;
        }

        .add-complaint-button:hover {
          background: #db4437;
          border-color: #db4437;
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(219, 68, 55, 0.2);
        }

        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.8);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 20px;
        }

        .modal-content {
          background: #ffffff;
          border-radius: 12px;
          width: 100%;
          max-width: 400px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 15px 20px;
          border-bottom: 1px solid #e5e5e5;
        }

        .modal-title {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: #000000;
        }

        .modal-close {
          background: none;
          border: none;
          color: #000000;
          font-size: 24px;
          cursor: pointer;
          padding: 0;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .modal-body {
          padding: 20px;
        }

        .modal-body p {
          margin: 0;
          font-size: 16px;
          line-height: 1.5;
          color: #333333;
        }

        .modal-footer {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
          padding: 15px 20px;
          border-top: 1px solid #e5e5e5;
        }

        .btn-secondary,
        .btn-danger {
          padding: 10px 20px;
          border-radius: 8px;
          border: none;
          font-weight: 600;
          cursor: pointer;
          font-size: 14px;
        }

        .btn-secondary {
          background: #666666;
          color: #ffffff;
        }

        .btn-danger {
          background: #f44336;
          color: #ffffff;
        }

        /* Responsive adjustments */
        @media (min-width: 768px) {
          .complaint-header {
            flex-direction: row;
          }

          .action-buttons {
            margin-top: 0;
            flex-direction: column;
            align-items: flex-end;
            justify-content: flex-start;
          }

          .button-group {
            margin-top: 10px;
          }
        }

        @media (max-width: 768px) {
          .sticky-top-section {
            top: 66px; /* Same as web for consistency */
          }

          .complaints-container {
            padding-top: 80px !important;
            padding-bottom: 40px !important;
          }

          .add-complaint-fab {
            bottom: 13%;
          }
        }

        @media (max-width: 480px) {
          .date-input {
            font-size: 0.9rem;
            padding: 0.625rem;
          }

          .complaint-card {
            margin-bottom: 12px;
          }

          .complaint-content {
            padding: 12px;
          }

          .complaint-title {
            font-size: 16px;
          }

          .product-name {
            font-size: 14px;
          }

          .complaint-details {
            font-size: 13px;
          }

          .action-button {
            width: 36px;
            height: 36px;
          }
        }

        /* Touch optimizations */
        @media (hover: none) and (pointer: coarse) {
          .add-complaint-button:hover {
            transform: none;
          }
          
          .action-button:hover {
            transform: none;
          }
        }
          .date-input {
    background: #f4f1f1;
    border: 1px solid #f4f1f1;
}
      `}</style>
    </React.Fragment>
  );
}

export default Complain;